interface GaState {
	pageGroup: string;
	pageLocation: string;
	preUrl: string;
	redirectedFrom: string;
}
export const useGaStore = defineStore("ga", {
	state: (): GaState => {
		return {
			pageGroup: "",
			preUrl: "",
			pageLocation: "",
			redirectedFrom: ""
		};
	},
	actions: {}
});
